var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{attrs:{"width":"10","height":"10","viewBox":"-2.5 -5 75 60","preserveAspectRatio":"none"}},[_c('path',{attrs:{"d":"M0,0 l35,50 l35,-50","stroke-linecap":"round","stroke-width":"5"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }